import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import swal from "sweetalert";
import "./Creategrn.css";
import Select from "react-select";
import moment from "moment";
import logUserActivity from "../utils/logUserActivity";
import { useRef } from "react";

const maxDate = moment().format("YYYY-MM-DD");

function CreateGrn() {
  const [listOfGrn, setlistOfGrn] = useState([]);
  const [Orders, setOrders] = useState([]);
  const [Medium, setMedium] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [batchid, setbatchid] = useState("");
  const [selectedSku, setsku] = useState("");
  const [quantityreceived, setquantityreceived] = useState("");
  const [goodinventory, setgoodinventory] = useState("");
  const [badinventory, setbadinventory] = useState("");
  const [quantity, setquantity] = useState("");
  const [challan, setchallan] = useState("");
  const [vehicleno, setvehicleno] = useState("");
  const [transportname, settransportname] = useState("");
  const [challanquantity, setchallanquantity] = useState("");
  const [grndate, setgrndate] = useState();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [title, setSelectedTitle] = useState(null);
  const [autoFilled, setAutoFilled] = useState(false);
  const [missexcss, setMissexcss] = useState("");
  const [img, setImg] = useState();
  const [loading, setLoading] = useState(false);
  const isSubmitting = useRef(false);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/api/creategrn/getgrn`).then(
      (response) => {
        setlistOfGrn(response.data);
      }
    );
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`).then((respon) => {
      setOrders(respon.data);
    });
  }, []);

  useEffect(() => {
    if (challanquantity !== "" && quantityreceived !== "") {
      setMissexcss(challanquantity - quantityreceived);
    }

    if (goodinventory !== "") {
      setbadinventory(quantityreceived - goodinventory);
    }
  }, [challanquantity, quantityreceived, goodinventory]);










  const createUser = async (event) => {
    event.preventDefault();

    if (loading || isSubmitting.current) return;

    if (
      !img ||
      !selectedOrder ||
      !selectedSku ||
      !Medium ||
      !purchasePrice ||
      !grndate ||
      !batchid ||
      !challan ||
      !vehicleno ||
      !transportname ||
      !quantity ||
      !challanquantity
    ) {
      swal({
        title: "Missing Fields",
        text: "All fields, including a challan image, are required.",
        icon: "error",
        button: "OK",
      });
      return;
    }

    isSubmitting.current = true;
    setLoading(true);

    const formData = new FormData();
    const orderValue = selectedOrder ? selectedOrder.value.toString() : "";
    const skuValue = selectedSku ? selectedSku.value.toString() : "";

    formData.append("orderno", orderValue);
    formData.append("title", title);
    formData.append("Medium", Medium);
    formData.append("purchasePrice", purchasePrice);
    formData.append("grndate", grndate);
    formData.append("batchid", batchid);
    formData.append("sku", skuValue);
    formData.append("challan", challan);
    formData.append("vehicleno", vehicleno);
    formData.append("transportname", transportname);
    formData.append("quantity", quantity);
    formData.append("challanquantity", challanquantity);

    const appendOptionalNumber = (field, value) => {
      if (value === "" || value === null || value === undefined) return;

      const numericValue = Number(value);
      if (Number.isFinite(numericValue)) {
        formData.append(field, String(numericValue));
      }
    };

    appendOptionalNumber("goodinventory", goodinventory);
    appendOptionalNumber("badinventory", badinventory);

    if (
      quantityreceived !== "" &&
      quantityreceived !== null &&
      quantityreceived !== undefined &&
      Number.isFinite(Number(quantityreceived))
    ) {
      const receivedQuantity = Number(quantityreceived);
      formData.append("quantityreceived", String(receivedQuantity));
      formData.append(
        "missexcss",
        String(Number(challanquantity) - receivedQuantity)
      );
    }

    if (img) {
      formData.append("challanimage", img);
    }

    try {
      const response = await Axios.post(
        `${INVENTORY_API_BASE_URL}/api/creategrn/creategrn`,
        formData
      );

      try {
        await logUserActivity("CREATE_GRN", {
          orderNo: orderValue,
          sku: skuValue,
          title,
          Medium,
          purchasePrice,
          grndate,
          batchid,
          challan,
          vehicleno,
          transportname,
          quantity,
          quantityreceived,
          challanquantity,
          goodinventory,
          badinventory,
          missexcss:
            quantityreceived !== "" && quantityreceived !== null
              ? Number(challanquantity) - Number(quantityreceived)
              : undefined,
        });
      } catch (activityError) {
        console.warn("GRN created, but activity logging failed:", activityError);
      }

      swal({
        title: "GRN Created",
        text: "",
        icon: "success",
      });

      setlistOfGrn((prev) => [...prev, response.data.data]);

      window.location.reload();
    } catch (error) {
      const serverMessage =
        error.response?.data?.message || error.response?.data?.error;
      console.error("Error creating GRN:", {
        message: error.message,
        status: error.response?.status,
        response: error.response?.data,
      });
      swal({
        title: "Error",
        text: serverMessage || error.message || "Failed to create GRN.",
        icon: "error",
      });
    } finally {
      isSubmitting.current = false;
      setLoading(false);
    }
  };

  const filteredOrders = Orders.filter((order) => order.ApprovalDate !== null);

  const orderOptions = filteredOrders.map((order) => ({
    value: order.orderid,
    label: order.orderid,
  }));

  const selectedOrderObj = filteredOrders.find(
    (order) => order.orderid === (selectedOrder && selectedOrder.value)
  );

  const updatedQuantity = selectedOrderObj
    ? selectedOrderObj.updatedQuantity
    : [];

  const skuOptions = updatedQuantity.map((quantityObj) => ({
    value: quantityObj.sku,
    label: quantityObj.sku,
  }));

  useEffect(() => {
    const selectedTitleObj = updatedQuantity.find(
      (quantityObj) => quantityObj.sku === (selectedSku && selectedSku.value)
    );

    if (selectedTitleObj) {
      setbatchid(selectedTitleObj.batchid);
      setSelectedTitle(selectedTitleObj.title);
      setquantity(selectedTitleObj.approvedquantity);
      setMedium(selectedTitleObj.Medium);
      setPurchasePrice(selectedTitleObj.purchasePrice);
      setAutoFilled(true);
    }
  }, [selectedSku, updatedQuantity]);

  return (
    <main className="create-grn-page">
      <div className="create-grn-shell">
        <header className="create-grn-header">
          <div>
            <p className="create-grn-eyebrow">Inventory / Receiving</p>
            <h1>Create Goods Receipt Note</h1>
            <p className="create-grn-description">
              Record an approved order delivery and its challan details.
            </p>
          </div>
          <span className="create-grn-status">
            <span aria-hidden="true" /> New receipt
          </span>
        </header>

        <form className="create-grn-card">
          <div className="create-grn-card-heading">
            <div>
              <h2>Receipt details</h2>
              <p>Choose an approved order to fill in its item information.</p>
            </div>
            <span className="create-grn-required-note">
              <span aria-hidden="true">*</span> Required fields
            </span>
          </div>

          <section className="create-grn-section" aria-labelledby="grn-order-heading">
            <div className="create-grn-section-heading">
              <span className="create-grn-section-number">01</span>
              <div>
                <h3 id="grn-order-heading">Order and item</h3>
                <p>Item details are filled from the selected order and SKU.</p>
              </div>
            </div>

            <div className="create-grn-grid">
              <div className="create-grn-field">
                <label htmlFor="create-grn-order">Order number <span>*</span></label>
                <Select
                  className="create-grn-select"
                  classNamePrefix="create-grn-select"
                  inputId="create-grn-order"
                  name="orderno"
                  options={orderOptions}
                  value={selectedOrder}
                  onChange={(selectedOption) => setSelectedOrder(selectedOption)}
                  placeholder="Select an approved order"
                  aria-label="Order number"
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="create-grn-sku">SKU <span>*</span></label>
                <Select
                  className="create-grn-select"
                  classNamePrefix="create-grn-select"
                  inputId="create-grn-sku"
                  name="sku"
                  options={skuOptions}
                  value={selectedSku}
                  onChange={(selectedOption) => setsku(selectedOption)}
                  placeholder="Select an SKU"
                  aria-label="SKU"
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="create-grn-batch">Batch ID <span>*</span></label>
                <input
                  id="create-grn-batch"
                  className="create-grn-input"
                  type="text"
                  name="batchid"
                  value={batchid}
                  required="required"
                  onChange={(event) => setbatchid(event.target.value)}
                  readOnly={autoFilled}
                />
              </div>

              <div className="create-grn-field create-grn-field--wide">
                <label htmlFor="create-grn-title">Title <span>*</span></label>
                <input
                  id="create-grn-title"
                  className="create-grn-input"
                  type="text"
                  name="title"
                  value={title}
                  required="required"
                  onChange={(event) => setSelectedTitle(event.target.value)}
                  readOnly={autoFilled}
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="create-grn-medium">Medium <span>*</span></label>
                <input
                  id="create-grn-medium"
                  className="create-grn-input"
                  type="text"
                  name="Medium"
                  value={Medium}
                  required="required"
                  onChange={(event) => setMedium(event.target.value)}
                  readOnly={autoFilled}
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="create-grn-price">Purchase price <span>*</span></label>
                <input
                  id="create-grn-price"
                  className="create-grn-input"
                  type="text"
                  name="purchasePrice"
                  value={purchasePrice}
                  required="required"
                  onChange={(event) => setPurchasePrice(event.target.value)}
                  readOnly={autoFilled}
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="create-grn-ordered-quantity">
                  Ordered quantity <span>*</span>
                </label>
                <input
                  id="create-grn-ordered-quantity"
                  className="create-grn-input"
                  type="number"
                  name="quantity"
                  value={quantity}
                  required="required"
                  onChange={(event) => setquantity(event.target.value)}
                  readOnly={autoFilled}
                />
              </div>
            </div>
          </section>

          <section className="create-grn-section" aria-labelledby="grn-delivery-heading">
            <div className="create-grn-section-heading">
              <span className="create-grn-section-number">02</span>
              <div>
                <h3 id="grn-delivery-heading">Delivery information</h3>
                <p>Enter the details shown on the goods challan.</p>
              </div>
            </div>

            <div className="create-grn-grid">
              <div className="create-grn-field">
                <label htmlFor="create-grn-date">Goods received date <span>*</span></label>
                <input
                  id="create-grn-date"
                  className="create-grn-input"
                  type="date"
                  max={maxDate}
                  onChange={(event) => setgrndate(event.target.value)}
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="create-grn-challan">Challan number <span>*</span></label>
                <input
                  id="create-grn-challan"
                  className="create-grn-input"
                  type="text"
                  name="challan"
                  required="required"
                  onChange={(event) => setchallan(event.target.value)}
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="create-grn-vehicle">Vehicle number <span>*</span></label>
                <input
                  id="create-grn-vehicle"
                  className="create-grn-input"
                  type="text"
                  name="vehicleno"
                  required="required"
                  onChange={(event) => setvehicleno(event.target.value)}
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="create-grn-transport">Transport <span>*</span></label>
                <input
                  id="create-grn-transport"
                  className="create-grn-input"
                  type="text"
                  name="transportname"
                  required="required"
                  onChange={(event) => settransportname(event.target.value)}
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="create-grn-challan-quantity">
                  Quantity as per challan <span>*</span>
                </label>
                <input
                  id="create-grn-challan-quantity"
                  className="create-grn-input"
                  type="number"
                  name="challanquantity"
                  required="required"
                  onChange={(event) => setchallanquantity(event.target.value)}
                />
              </div>

              <div className="create-grn-field">
                <label htmlFor="img1">Challan image</label>
                <input
                  className="create-grn-input create-grn-file-input"
                  type="file"
                  accept="image/*"
                  required
                  id="img1"
                  name="img"
                  onChange={(event) => setImg(event.target.files[0])}
                />
              </div>
            </div>
          </section>

          <footer className="create-grn-footer">
            <p>Check the order and delivery details before saving.</p>
            <button
              className="create-grn-submit"
              type="button"
              onClick={createUser}
              disabled={loading}
            >
              {loading ? "Saving…" : "Create GRN"}
            </button>
          </footer>
        </form>
      </div>
    </main>
  );
}

export default CreateGrn;
